import { useState, useContext } from "react";
import styles from "./styles.module.css";
import Modal from "../../../modal";
import { db } from "../../../firebase";
import { useParams } from "react-router-dom";

export default function Add({ setStyle, blocks }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [component, setComponent] = useState("");
  const { appId } = useParams();

  const AddStyle = () => {
    if (component === "") {
      return alert("Please Select a Component");
    }
    if (name === "") {
      return alert("Please Add a Style Name");
    }
    const doc = db.collection("apps").doc(appId).collection("styles").doc();
    const props = {};
    blocks
      .find((x) => x.name === component)
      .props.filter((x) => x.editorParams.styleName)
      .forEach((x) => {
        props[x.name] = x.editorParams.default;
      });
    const newStyle = {
      name,
      component,
      props,
      id: doc.id,
    };

    doc.set(newStyle);
    setStyle(newStyle);
    setOpen(false);
  };

  return (
    <>
      <div onClick={() => setOpen(true)} className={styles.addButton}>
        ADD STYLE
      </div>
      <Modal onClose={() => setOpen(false)} open={open}>
        <div className={styles.addContainer}>
          <div className={styles.title}>Add Style</div>
          <div className={styles.inputTitle}>Name</div>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={"input"}
          />
          <div className={styles.inputTitle}>Component Type</div>
          <select
            value={component}
            onChange={(e) => setComponent(e.target.value)}
            className={styles.select}
          >
            <option disabled value={""}>
              select
            </option>
            {blocks.map((b) => {
              return (
                <option key={b.name} value={b.name}>
                  {b.displayName}
                </option>
              );
            })}
          </select>
          <button onClick={AddStyle} className={styles.button}>
            Add
          </button>
        </div>
      </Modal>
    </>
  );
}
